import { render } from "./QaTestCasesPage.vue?vue&type=template&id=31024426&scoped=true"
import script from "./QaTestCasesPage.vue?vue&type=script&lang=js"
export * from "./QaTestCasesPage.vue?vue&type=script&lang=js"

import "./QaTestCasesPage.vue?vue&type=style&index=0&id=31024426&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31024426"]])

export default __exports__